import { ActionIcon, Tooltip } from "@mantine/core";
import { forwardRef } from "react";
import { LuBold, LuItalic, LuStrikethrough } from "react-icons/lu";

export default function TextStyling({ editor, language }) {
  const textStylings = [
    {
      type: "bold",
      level: 1,
      icon: <LuBold />,
      label: language.TextEditor.Bold,
      onClick: () => editor.chain().focus().toggleBold().run(),
    },
    {
      type: "italic",
      level: 2,
      icon: <LuItalic />,
      label: language.TextEditor.Italic,
      onClick: () => editor.chain().focus().toggleItalic().run(),
    },
    // {
    //   type: "strike",
    //   level: 3,
    //   icon: <LuStrikethrough />,
    //   label: language.TextEditor.Strikethrough,
    //   onClick: () => editor.chain().focus().toggleStrike().run(),
    // },
  ];
  return (
    <>
      {textStylings.map((text) => {
        const TooltipComponent = forwardRef((props, ref) => (
          <div ref={ref} {...props} style={{ pointerEvents: "none" }}>
            {text.icon}
          </div>
        ));

        return (
          <div key={text.type}>
            <div>
              <Tooltip
                classNames={{ tooltip: "tooltip-body" }}
                transitionProps={{ duration: 200 }}
                openDelay={500}
                multiline
                events={{ hover: true, focus: true, touch: true }}
                label={text.label}
              >
                <ActionIcon
                  className="text-editor-button"
                  type="button"
                  size="md"
                  w="40"
                  variant={editor.isActive(text.type) ? "light" : "subtle"}
                  onClick={text.onClick}
                  color="black"
                >
                  <TooltipComponent />
                </ActionIcon>
              </Tooltip>
            </div>
          </div>
        );
      })}
    </>
  );
}
